import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import SimpleTreeControlView, {
    ITreeNode
} from '@techsee/techsee-ui-common/lib/simple-tree-control-view/SimpleTreeControlView';
import {PredefinedTreeTemplate} from './PredefinedTree.template';
import {ITreeController} from '../../../contract';

interface PredefinedTreeProps {
    ctrl: ITreeController;
    className?: string;
}
const ObserverTree = observer(SimpleTreeControlView);

@observer
export class PredefinedTree extends TechseeBaseComponent<PredefinedTreeProps> {
    renderInternal(): JSX.Element {
        const {ctrl, className} = this.props;

        if (ctrl.empty) {
            return <></>;
        }

        return (
            <div className={className}>
                <ObserverTree
                    className='tree-dark'
                    style={{overflowX: 'hidden'}}
                    data={ctrl.treeData as ITreeNode}
                    onNodeExpandCollapseClick={ctrl.expandCollapse}
                    onNodeSelectClick={ctrl.selectNode}
                    templateComponent={PredefinedTreeTemplate}
                    options={{startDepth: 1}}
                />
            </div>
        );
    }
}
